import { c as _c } from "react/compiler-runtime";
import { TableHeader, TableHeaderCell } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { TABLE_COLUMN_CLASSNAMES } from "./styles";
export function ItemAttributesTableHeader() {
  const $ = _c(26);
  const t = useTranslations("ItemAttributesTableHeader");
  let t0;
  if ($[0] !== t) {
    t0 = t("attribute");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TableHeaderCell className={TABLE_COLUMN_CLASSNAMES.attribute}>{t0}</TableHeaderCell>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("trait");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <TableHeaderCell className={TABLE_COLUMN_CLASSNAMES.trait}>{t2}</TableHeaderCell>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("countPercent");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <TableHeaderCell className={TABLE_COLUMN_CLASSNAMES.count}>{t4}</TableHeaderCell>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("floor");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <TableHeaderCell className={TABLE_COLUMN_CLASSNAMES.floor}>{t6}</TableHeaderCell>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("topOffer");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <TableHeaderCell className={TABLE_COLUMN_CLASSNAMES.topOffer}>{t8}</TableHeaderCell>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t3 || $[22] !== t5 || $[23] !== t7 || $[24] !== t9) {
    t10 = <TableHeader className="bg-bg-primary">{t1}{t3}{t5}{t7}{t9}</TableHeader>;
    $[20] = t1;
    $[21] = t3;
    $[22] = t5;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}